import { configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import type { TypedUseSelectorHook } from 'react-redux'
import LoginReducer from './Features/Login/loginState'
import LayoutReducer from './Features/Layout/layoutState'
import UserReducer from './Features/Users/UsersState'
import LogReducer from './Features/Log/log'
import ContractsReducer from './Features/Contracts/contractsState'
import ContractFilesReducer from './Features/Contracts/contractFilesState'
import ContractSigningReducer from './Features/Contracts/contractSigningState'
import TemplateDesignerReducer from './Features/TemplateDesigner/templateDesignerState'
import TemplatesReducer from './Features/TemplateDesigner/TemplatesState'
import ProductsReducer from './Features/Products/productState'
import NotificationsReducer from './Features/Notification/Notifications'
import ModulesReducer from './Features/Modules/Modules'
import SettingsReducer from './Features/Settings/SettingsState'
import MetricReducer from './Features/Metric/metricState'
import AdministrationReducer from './Features/ITL-Administration/AdministrationState'
import TicketsReducer from './Features/Tickets/ticketState'
import TemplateAttachmentReducer from './Features/TemplateAttachments/templateAttachmentState'
import { signal } from './Utils/SignalR/SignalR'

const store = configureStore({
  reducer: {
    Login: LoginReducer,
    Metric: MetricReducer,
    Layout: LayoutReducer,
    Users: UserReducer,
    Logs: LogReducer,
    Contracts: ContractsReducer,
    ContractFiles: ContractFilesReducer,
    ContractSigning: ContractSigningReducer,
    Modules: ModulesReducer,
    Notifications: NotificationsReducer,
    Products: ProductsReducer,
    TemplateDesigner: TemplateDesignerReducer,
    Setting: SettingsReducer,
    Templates: TemplatesReducer,
    Administration: AdministrationReducer,
    Tickets: TicketsReducer,
    TemplateAttachments: TemplateAttachmentReducer,
  },
  middleware: [signal],
}) //createStore(changeState)
export default store

// State/dispatch types inferred from the reducer map above.
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

// Drop-in replacements for useDispatch/useSelector in .ts/.tsx files,
// pre-bound to this store's types.
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector
